import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../language/HrbTranslate'
import Lang from '../language/services/Lang'

const SideNavBasicLink = props => {
    const { elementId, linkKey, textKey} = props    
    return (
        <div id={elementId} className='column is-10 is-offset-2 p-0'>
            <a href={Lang.getCurrentValue(linkKey)} target='_blank' rel='noopener noreferrer'>
                <HrbTranslate text={textKey} />
            </a>
        </div>
    )
}

SideNavBasicLink.propTypes = {
    elementId: PropTypes.string.isRequired,
    linkKey: PropTypes.string.isRequired,
    textKey: PropTypes.string.isRequired
}

export default SideNavBasicLink